// Single source of truth for device line-art icons.
// 64x64 viewBox, ink stroke (#1B232C) 1.75, fill none. Used identically in:
//  - the React palette & canvas nodes
//  - draw.io export (embedded as data-URI <image>)
//  - SVG/PDF export (inlined)

export const INK = '#1B232C';

export const VLAN_COLORS = [
  '#0B5FFF',
  '#0F7B6C',
  '#B7791F',
  '#C2410C',
  '#0E7490',
  '#7C3AED',
  '#334155',
  '#9D174D',
];

// inner SVG markup per device (no <svg> wrapper, no group styling)
const ICONS = {
  switch:
    '<rect x="6" y="23" width="52" height="19" rx="2.5"/>' +
    '<path d="M15 32.5 h13"/><path d="M24 28.5 l4 4 -4 4"/>' +
    '<path d="M49 32.5 h-13"/><path d="M40 28.5 l-4 4 4 4"/>' +
    '<circle cx="12" cy="38" r="1.3" fill="#1B232C" stroke="none"/>' +
    '<circle cx="52" cy="38" r="1.3" fill="#1B232C" stroke="none"/>',
  firewall:
    '<rect x="8" y="16" width="48" height="32" rx="2"/>' +
    '<path d="M8 26.7 h48 M8 37.3 h48"/>' +
    '<path d="M24 16 v10.7 M40 16 v10.7"/>' +
    '<path d="M16 26.7 v10.6 M32 26.7 v10.6 M48 26.7 v10.6"/>' +
    '<path d="M24 37.3 v10.7 M40 37.3 v10.7"/>',
  accesspoint:
    '<rect x="20" y="36" width="24" height="13" rx="2.5"/>' +
    '<circle cx="32" cy="42.5" r="1.6" fill="#1B232C" stroke="none"/>' +
    '<path d="M25 28 a10 10 0 0 1 14 0"/>' +
    '<path d="M20.5 22.5 a17 17 0 0 1 23 0"/>',
  router:
    '<rect x="8" y="30" width="48" height="15" rx="2.5"/>' +
    '<path d="M17 37.5 h11"/><path d="M24 33.5 l4 4 -4 4"/>' +
    '<path d="M47 37.5 h-11"/><path d="M40 33.5 l-4 4 4 4"/>' +
    '<path d="M22 24 l8 0 0 -8"/><path d="M27 16 l3 0 0 3"/>' +
    '<path d="M42 24 l-8 0 0 -8"/><path d="M37 16 l-3 0 0 3"/>',
  server:
    '<rect x="17" y="8" width="30" height="48" rx="2.5"/>' +
    '<path d="M17 23 h30 M17 38 h30"/>' +
    '<circle cx="23" cy="15.5" r="1.4" fill="#1B232C" stroke="none"/>' +
    '<circle cx="23" cy="30.5" r="1.4" fill="#1B232C" stroke="none"/>' +
    '<circle cx="23" cy="45.5" r="1.4" fill="#1B232C" stroke="none"/>' +
    '<path d="M30 15.5 h11 M30 30.5 h11 M30 45.5 h11"/>',
  pc:
    '<rect x="9" y="13" width="46" height="29" rx="2.5"/>' +
    '<path d="M13 17 h38 v21 h-38 z" stroke-width="1"/>' +
    '<path d="M26 47 l2 -5 h8 l2 5"/>' +
    '<path d="M20 51 h24"/>',
  cloud:
    '<path d="M21 44 h24 a9 9 0 0 0 1.5 -17.9 a12 12 0 0 0 -22.6 -3.2 a8.5 8.5 0 0 0 -2.9 21.1 z"/>',
  loadbalancer:
    '<rect x="23" y="26" width="18" height="12" rx="2.5"/>' +
    '<path d="M32 26 v-8"/><path d="M28 21.5 l4 -4 4 4"/>' +
    '<path d="M23 32 h-11"/><path d="M16 27.5 l-4.5 4.5 4.5 4.5"/>' +
    '<path d="M41 32 h11"/><path d="M48 27.5 l4.5 4.5 -4.5 4.5"/>' +
    '<path d="M32 38 v8"/><path d="M28 42 l4 4 4 -4"/>',
  storage:
    '<path d="M16 16 c0 -3.6 32 -3.6 32 0 v32 c0 3.6 -32 3.6 -32 0 z"/>' +
    '<path d="M16 16 c0 3.6 32 3.6 32 0"/>' +
    '<path d="M16 30.6 c0 3.6 32 3.6 32 0"/>' +
    '<circle cx="41" cy="22" r="1.4" fill="#1B232C" stroke="none"/>' +
    '<circle cx="41" cy="37" r="1.4" fill="#1B232C" stroke="none"/>',
  ipphone:
    '<path d="M16 27 q0 -9 9 -9 h14 q9 0 9 9"/>' +
    '<rect x="14" y="27" width="36" height="24" rx="3"/>' +
    '<rect x="20" y="31" width="24" height="9" rx="1"/>' +
    '<path d="M21 45 h5 M29.5 45 h5 M38 45 h5"/>',
  printer:
    '<rect x="13" y="27" width="38" height="18" rx="2.5"/>' +
    '<rect x="20" y="13" width="24" height="14" rx="1"/>' +
    '<rect x="20" y="39" width="24" height="13" rx="1"/>' +
    '<circle cx="45" cy="34" r="1.5" fill="#1B232C" stroke="none"/>',
  modem:
    '<rect x="10" y="31" width="44" height="14" rx="2.5"/>' +
    '<circle cx="18" cy="38" r="1.4" fill="#1B232C" stroke="none"/>' +
    '<circle cx="24" cy="38" r="1.4" fill="#1B232C" stroke="none"/>' +
    '<path d="M40 38 h9"/>' +
    '<path d="M39 31 l3 -13"/><path d="M46 31 l5 -17"/>',
  patchpanel:
    '<rect x="5" y="24" width="54" height="16" rx="2"/>' +
    '<rect x="10" y="29" width="5.5" height="6" rx="0.6"/>' +
    '<rect x="18" y="29" width="5.5" height="6" rx="0.6"/>' +
    '<rect x="26" y="29" width="5.5" height="6" rx="0.6"/>' +
    '<rect x="34" y="29" width="5.5" height="6" rx="0.6"/>' +
    '<rect x="42" y="29" width="5.5" height="6" rx="0.6"/>' +
    '<rect x="50" y="29" width="5.5" height="6" rx="0.6"/>',

  // --- Haustechnik / Gebäudeautomation ---
  buscontroller:
    '<rect x="17" y="15" width="30" height="34" rx="2.5"/>' +
    '<path d="M23 15 v-4 M32 15 v-4 M41 15 v-4 M23 49 v4 M32 49 v4 M41 49 v4"/>' +
    '<rect x="22" y="20" width="20" height="9" rx="1"/>' +
    '<circle cx="26" cy="40" r="2" fill="#1B232C" stroke="none"/>' +
    '<circle cx="32" cy="40" r="2" fill="#1B232C" stroke="none"/>' +
    '<circle cx="38" cy="40" r="2" fill="#1B232C" stroke="none"/>',
  hvac:
    '<rect x="8" y="19" width="48" height="18" rx="4"/>' +
    '<path d="M8 30 h48"/>' +
    '<path d="M15 43 q3 4 6 0 M29 43 q3 4 6 0 M43 43 q3 4 6 0"/>',
  heatpump:
    '<rect x="12" y="14" width="40" height="36" rx="3"/>' +
    '<circle cx="32" cy="32" r="12"/>' +
    '<path d="M32 32 l0 -12 M32 32 l10.4 6 M32 32 l-10.4 6"/>' +
    '<circle cx="32" cy="32" r="2.3" fill="#1B232C" stroke="none"/>' +
    '<path d="M18 46.5 h28"/>',
  sensor:
    '<rect x="20" y="15" width="24" height="19" rx="4"/>' +
    '<circle cx="32" cy="24.5" r="4.5"/>' +
    '<path d="M24 41 a12 12 0 0 0 16 0"/>' +
    '<path d="M20 46 a18 18 0 0 0 24 0"/>',
  camera:
    '<path d="M22 13 h22"/>' +
    '<path d="M33 13 v6"/>' +
    '<rect x="13" y="22" width="28" height="16" rx="8"/>' +
    '<circle cx="38" cy="30" r="5.5"/>' +
    '<circle cx="38" cy="30" r="2" fill="#1B232C" stroke="none"/>' +
    '<path d="M31 38 v5"/>',
  accesscontrol:
    '<rect x="18" y="11" width="24" height="43" rx="1.5"/>' +
    '<circle cx="37" cy="33" r="1.8" fill="#1B232C" stroke="none"/>' +
    '<rect x="45" y="24" width="9" height="15" rx="1.5"/>' +
    '<path d="M47.5 28 h4 M47.5 31.5 h4 M47.5 35 h4"/>',
  actuator:
    '<rect x="16" y="16" width="32" height="32" rx="2.5"/>' +
    '<path d="M24 16 v-4 M40 16 v-4 M24 48 v4 M40 48 v4"/>' +
    '<circle cx="25" cy="34" r="2.2" fill="#1B232C" stroke="none"/>' +
    '<circle cx="39" cy="34" r="2.2" fill="#1B232C" stroke="none"/>' +
    '<path d="M25 34 l13 -8"/>',

  // --- Industrie ---
  plc:
    '<rect x="15" y="12" width="34" height="40" rx="2.5"/>' +
    '<rect x="20" y="17" width="24" height="8" rx="1"/>' +
    '<circle cx="23" cy="33" r="1.6" fill="#1B232C" stroke="none"/>' +
    '<circle cx="29" cy="33" r="1.6" fill="#1B232C" stroke="none"/>' +
    '<circle cx="35" cy="33" r="1.6" fill="#1B232C" stroke="none"/>' +
    '<circle cx="41" cy="33" r="1.6" fill="#1B232C" stroke="none"/>' +
    '<circle cx="23" cy="41" r="1.6" fill="#1B232C" stroke="none"/>' +
    '<circle cx="29" cy="41" r="1.6" fill="#1B232C" stroke="none"/>' +
    '<circle cx="35" cy="41" r="1.6" fill="#1B232C" stroke="none"/>' +
    '<circle cx="41" cy="41" r="1.6" fill="#1B232C" stroke="none"/>' +
    '<path d="M15 47 h34"/>',
  hmi:
    '<rect x="10" y="13" width="44" height="34" rx="3"/>' +
    '<rect x="15" y="18" width="34" height="20" rx="1.5"/>' +
    '<path d="M21 25 h9 M21 29 h15 M21 33 h6"/>' +
    '<circle cx="44" cy="43" r="1.7" fill="#1B232C" stroke="none"/>' +
    '<circle cx="20" cy="43" r="1.7" fill="#1B232C" stroke="none"/>',
  iomodule:
    '<rect x="14" y="18" width="36" height="28" rx="2.5"/>' +
    '<path d="M14 32 h36"/>' +
    '<path d="M21 18 v14 M28 18 v14 M35 18 v14 M42 18 v14"/>' +
    '<path d="M21 32 v14 M28 32 v14 M35 32 v14 M42 32 v14"/>',
  fieldgateway:
    '<rect x="17" y="20" width="30" height="24" rx="2.5"/>' +
    '<path d="M17 32 h-9 M9 28 l-4.5 4 4.5 4"/>' +
    '<path d="M47 32 h9 M55 28 l4.5 4 -4.5 4"/>' +
    '<path d="M24 27 h16 M24 32 h16 M24 37 h16"/>',
  vfd:
    '<rect x="17" y="12" width="30" height="40" rx="2.5"/>' +
    '<path d="M24 12 v-3 M32 12 v-3 M40 12 v-3"/>' +
    '<path d="M24 52 v3 M32 52 v3 M40 52 v3"/>' +
    '<rect x="22" y="17" width="20" height="8" rx="1"/>' +
    '<path d="M22 36 q4 -8 8 0 t8 0"/>',
  robot:
    '<path d="M19 52 h18"/>' +
    '<rect x="23" y="45" width="10" height="7" rx="1"/>' +
    '<circle cx="28" cy="45" r="2.4"/>' +
    '<path d="M28 45 l-5 -16"/>' +
    '<circle cx="23" cy="29" r="2.4"/>' +
    '<path d="M23 29 l16 -7"/>' +
    '<circle cx="39" cy="22" r="2.4"/>' +
    '<path d="M39 22 l5 -5 M39 22 l5 3"/>',
  machine:
    '<rect x="12" y="20" width="40" height="28" rx="2.5"/>' +
    '<path d="M20 20 v-4 h9 v4 M35 20 v-6 h9 v6"/>' +
    '<circle cx="32" cy="34" r="7"/>' +
    '<circle cx="32" cy="34" r="2.4" fill="#1B232C" stroke="none"/>' +
    '<path d="M32 25 v3 M32 40 v3 M23 34 h3 M41 34 h3 M25.5 27.5 l2 2 M38.5 27.5 l-2 2 M25.5 40.5 l2 -2 M38.5 40.5 l-2 -2"/>',

  // --- PV & Energie ---
  inverter:
    '<rect x="14" y="16" width="36" height="32" rx="2.5"/>' +
    '<path d="M32 16 v32"/>' +
    '<path d="M19 28 h8"/>' +
    '<path d="M19 34 h2 M24 34 h2"/>' +
    '<path d="M36 32 q3 -7 6 0 t6 0"/>',
  battery:
    '<rect x="16" y="14" width="32" height="40" rx="3"/>' +
    '<rect x="27" y="9" width="10" height="5" rx="1"/>' +
    '<path d="M34 22 l-8 13 h6 l-3 11 11 -15 h-6 z"/>',
  meter:
    '<rect x="14" y="12" width="36" height="40" rx="3"/>' +
    '<rect x="19" y="17" width="26" height="11" rx="1.5"/>' +
    '<path d="M23 22.5 h3 M28 22.5 h3 M33 22.5 h3 M38 22.5 h3"/>' +
    '<circle cx="32" cy="40" r="6"/>' +
    '<path d="M32 40 l4 -3"/>',
  wallbox:
    '<rect x="18" y="12" width="22" height="34" rx="3"/>' +
    '<rect x="23" y="17" width="12" height="9" rx="1.5"/>' +
    '<path d="M24 32 h10"/>' +
    '<path d="M40 22 q10 2 10 12 q0 8 -7 9"/>' +
    '<circle cx="42" cy="46" r="4"/>',

  // --- Generisch & Sonstiges (neutral placeholders for anything not covered) ---
  generic:
    '<rect x="12" y="17" width="40" height="30" rx="3"/>' +
    '<path d="M12 26 h40"/>' +
    '<circle cx="17.5" cy="21.5" r="1.4" fill="#1B232C" stroke="none"/>' +
    '<circle cx="22.5" cy="21.5" r="1.4" fill="#1B232C" stroke="none"/>' +
    '<path d="M19 34 h26 M19 40 h16"/>',
  blackbox:
    '<rect x="14" y="14" width="36" height="36" rx="3" stroke-dasharray="4 3"/>' +
    '<path d="M26.5 26.5 a5.5 5.5 0 1 1 7.6 5.1 c-1.6 .7 -2.1 1.6 -2.1 3.4 v1"/>' +
    '<circle cx="32" cy="41" r="1.5" fill="#1B232C" stroke="none"/>',
  iot:
    '<rect x="22" y="25" width="20" height="20" rx="2.5"/>' +
    '<rect x="28" y="31" width="8" height="8" rx="1"/>' +
    '<path d="M27 25 v-4 M37 25 v-4 M27 45 v4 M37 45 v4 M22 30 h-4 M22 40 h-4 M42 30 h4 M42 40 h4"/>' +
    '<path d="M45 17 a6 6 0 0 1 3.5 3.5"/>' +
    '<path d="M45 11.5 a11.5 11.5 0 0 1 8.5 8.5"/>',
  mobile:
    '<rect x="21" y="10" width="22" height="44" rx="3.5"/>' +
    '<path d="M28 15.5 h8"/>' +
    '<circle cx="32" cy="48" r="1.8" fill="#1B232C" stroke="none"/>',
  display:
    '<rect x="9" y="14" width="46" height="30" rx="2.5"/>' +
    '<path d="M32 44 v6 M23 50 h18"/>' +
    '<path d="M28 23.5 l10 5.5 -10 5.5 z"/>',
  ups:
    '<rect x="14" y="12" width="36" height="40" rx="3"/>' +
    '<rect x="19" y="17" width="26" height="9" rx="1.5"/>' +
    '<path d="M33 30 l-6 9 h5.5 l-2.5 8 8 -11 h-5.5 z"/>' +
    '<path d="M19 48 h7 M38 48 h7"/>',
  mediaconverter:
    '<rect x="13" y="24" width="38" height="16" rx="2.5"/>' +
    '<path d="M13 32 h-7"/>' +
    '<path d="M51 32 h7" stroke-dasharray="2 2"/>' +
    '<rect x="18" y="29" width="7" height="6" rx="0.8"/>' +
    '<path d="M29 32 h9"/><path d="M35 29 l3 3 -3 3"/>' +
    '<circle cx="44.5" cy="32" r="2.8"/>',
  rack:
    '<rect x="16" y="8" width="32" height="48" rx="2"/>' +
    '<path d="M16 18 h32 M16 28 h32 M16 38 h32 M16 48 h32"/>' +
    '<circle cx="20.5" cy="13" r="1.1" fill="#1B232C" stroke="none"/><circle cx="43.5" cy="13" r="1.1" fill="#1B232C" stroke="none"/>' +
    '<circle cx="20.5" cy="23" r="1.1" fill="#1B232C" stroke="none"/><circle cx="43.5" cy="23" r="1.1" fill="#1B232C" stroke="none"/>' +
    '<circle cx="20.5" cy="33" r="1.1" fill="#1B232C" stroke="none"/><circle cx="43.5" cy="33" r="1.1" fill="#1B232C" stroke="none"/>' +
    '<circle cx="20.5" cy="43" r="1.1" fill="#1B232C" stroke="none"/><circle cx="43.5" cy="43" r="1.1" fill="#1B232C" stroke="none"/>' +
    '<path d="M26 52 h12"/>',
  antenna:
    '<path d="M32 54 v-22"/>' +
    '<path d="M23 54 h18"/>' +
    '<circle cx="32" cy="29" r="3"/>' +
    '<path d="M24 21.5 a11 11 0 0 1 16 0"/>' +
    '<path d="M18.5 15.5 a19 19 0 0 1 27 0"/>',
  user:
    '<circle cx="32" cy="22" r="8"/>' +
    '<path d="M16 52 a16 16 0 0 1 32 0"/>',
  site:
    '<rect x="14" y="20" width="28" height="34" rx="1.5"/>' +
    '<path d="M42 30 h8 v24 h-8"/>' +
    '<path d="M20 27 h4 M28 27 h4 M20 34 h4 M28 34 h4 M20 41 h4 M28 41 h4"/>' +
    '<path d="M25 54 v-7 h6 v7"/>' +
    '<path d="M45 36 h2 M45 42 h2 M45 48 h2"/>',
  junction:
    '<circle cx="32" cy="32" r="6"/>' +
    '<path d="M32 26 v-13 M32 38 v13 M26 32 h-13 M38 32 h13"/>' +
    '<circle cx="32" cy="11" r="1.8" fill="#1B232C" stroke="none"/><circle cx="32" cy="53" r="1.8" fill="#1B232C" stroke="none"/>' +
    '<circle cx="11" cy="32" r="1.8" fill="#1B232C" stroke="none"/><circle cx="53" cy="32" r="1.8" fill="#1B232C" stroke="none"/>',
};

export const DEVICE_CATEGORIES = [
  { key: 'network', de: 'Netzwerk & IT', en: 'Network & IT' },
  { key: 'building', de: 'Haustechnik', en: 'Building automation' },
  { key: 'industrial', de: 'Industrie', en: 'Industrial' },
  { key: 'energy', de: 'PV & Energie', en: 'PV & Energy' },
  { key: 'generic', de: 'Generisch & Sonstiges', en: 'Generic & misc.' },
];

export const DEVICE_TYPES = [
  // Netzwerk & IT
  { key: 'switch', de: 'Switch', en: 'Switch', cat: 'network' },
  { key: 'firewall', de: 'Firewall', en: 'Firewall', cat: 'network' },
  { key: 'accesspoint', de: 'Access Point', en: 'Access Point', cat: 'network' },
  { key: 'router', de: 'Router', en: 'Router', cat: 'network' },
  { key: 'loadbalancer', de: 'Load Balancer', en: 'Load Balancer', cat: 'network' },
  { key: 'modem', de: 'Modem', en: 'Modem', cat: 'network' },
  { key: 'patchpanel', de: 'Patchpanel (Passiv)', en: 'Patch Panel (passive)', cat: 'network' },
  { key: 'server', de: 'Server', en: 'Server', cat: 'network' },
  { key: 'storage', de: 'Storage / NAS', en: 'Storage / NAS', cat: 'network' },
  { key: 'pc', de: 'Client / PC', en: 'Client / PC', cat: 'network' },
  { key: 'ipphone', de: 'IP-Telefon', en: 'IP Phone', cat: 'network' },
  { key: 'printer', de: 'Drucker', en: 'Printer', cat: 'network' },
  { key: 'cloud', de: 'Cloud / Internet', en: 'Cloud / Internet', cat: 'network' },
  // Haustechnik / Gebäudeautomation
  { key: 'buscontroller', de: 'Gebäudesteuerung', en: 'Building controller', cat: 'building' },
  { key: 'hvac', de: 'Klimagerät (HLK)', en: 'HVAC unit', cat: 'building' },
  { key: 'heatpump', de: 'Wärmepumpe', en: 'Heat pump', cat: 'building' },
  { key: 'sensor', de: 'Sensor', en: 'Sensor', cat: 'building' },
  { key: 'camera', de: 'IP-Kamera', en: 'IP camera', cat: 'building' },
  { key: 'accesscontrol', de: 'Zutrittskontrolle', en: 'Access control', cat: 'building' },
  { key: 'actuator', de: 'Schaltaktor', en: 'Switch actuator', cat: 'building' },
  // Industrie
  { key: 'plc', de: 'SPS / PLC', en: 'PLC', cat: 'industrial' },
  { key: 'hmi', de: 'HMI-Panel', en: 'HMI panel', cat: 'industrial' },
  { key: 'iomodule', de: 'Remote-I/O', en: 'Remote I/O', cat: 'industrial' },
  { key: 'fieldgateway', de: 'Feldbus-Gateway', en: 'Fieldbus gateway', cat: 'industrial' },
  { key: 'vfd', de: 'Frequenzumrichter', en: 'VFD / Drive', cat: 'industrial' },
  { key: 'robot', de: 'Roboter', en: 'Robot', cat: 'industrial' },
  { key: 'machine', de: 'Maschine', en: 'Machine', cat: 'industrial' },
  // PV & Energie
  { key: 'inverter', de: 'Wechselrichter', en: 'Inverter', cat: 'energy' },
  { key: 'battery', de: 'Batteriespeicher', en: 'Battery storage', cat: 'energy' },
  { key: 'meter', de: 'Energiezähler', en: 'Energy meter', cat: 'energy' },
  { key: 'wallbox', de: 'Wallbox', en: 'Wallbox / EV charger', cat: 'energy' },
  // Generisch & Sonstiges
  { key: 'generic', de: 'Generisches Gerät', en: 'Generic device', cat: 'generic' },
  { key: 'blackbox', de: 'Unbekannt / Platzhalter', en: 'Unknown / placeholder', cat: 'generic' },
  { key: 'iot', de: 'IoT-Gerät', en: 'IoT device', cat: 'generic' },
  { key: 'mobile', de: 'Mobilgerät', en: 'Mobile device', cat: 'generic' },
  { key: 'display', de: 'Display / Bildschirm', en: 'Display / screen', cat: 'generic' },
  { key: 'ups', de: 'USV', en: 'UPS', cat: 'generic' },
  { key: 'mediaconverter', de: 'Medienkonverter', en: 'Media converter', cat: 'generic' },
  { key: 'rack', de: 'Rack / Schrank', en: 'Rack / cabinet', cat: 'generic' },
  { key: 'antenna', de: 'Antenne / Richtfunk', en: 'Antenna / point-to-point', cat: 'generic' },
  { key: 'junction', de: 'Verteiler / Knoten', en: 'Junction / node', cat: 'generic' },
  { key: 'user', de: 'Benutzer / Person', en: 'User / person', cat: 'generic' },
  { key: 'site', de: 'Gebäude / Standort', en: 'Building / site', cat: 'generic' },
];

export function deviceCategoryLabel(key, lang = 'de') {
  const c = DEVICE_CATEGORIES.find((x) => x.key === key);
  if (!c) return key;
  return lang === 'en' ? c.en : c.de;
}

// Passive (physical, non-configurable) device types. These have NO VLAN / IP /
// virtual-interface configuration of their own — they merely pass connections
// through (e.g. a patch panel). The connection dialog resolves their effective
// VLAN config from the nearest ACTIVE device on the other side (pass-through).
export const PASSIVE_DEVICE_TYPES = ['patchpanel'];

export function isPassiveDevice(deviceType) {
  return PASSIVE_DEVICE_TYPES.includes(deviceType);
}

export function deviceLabel(key, lang = 'de') {
  const d = DEVICE_TYPES.find((x) => x.key === key);
  if (!d) return key || '';
  return lang === 'en' ? d.en : d.de;
}

export function iconInner(key) {
  const inner = ICONS[key] || ICONS.switch;
  return (
    '<g fill="none" stroke="' + INK + '" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">' +
    inner +
    '</g>'
  );
}

export function iconFullSvg(key, size = 64) {
  return (
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="' +
    size +
    '" height="' +
    size +
    '">' +
    iconInner(key) +
    '</svg>'
  );
}

// URL-encoded SVG data URI. This format is safe inside mxGraph/draw.io styles:
// encodeURIComponent escapes ';' and '=' (the style delimiters) so the value
// can never break the style string, and it is a spec-valid data URI that
// draw.io renders natively (draw.io itself stores SVGs this way).
export function svgToDataUri(svg) {
  return 'data:image/svg+xml,' + encodeURIComponent(svg);
}

export function iconDataUri(key) {
  return svgToDataUri(iconFullSvg(key, 64));
}
